export default class PictoDeco {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
  }
}
